import React, { Component } from 'react';

import './style.less';
class Title extends Component {
    render() {
        return <div className='container-title'>
            {this.props.children}
        </div>
    }
}

export default Title;